export const CLEAR_SEARCH_EVENT = "clear-list-search"
